import { useEffect, useState } from "react";
import { Building2, Users, ShoppingBag, TrendingUp } from "lucide-react";
import { api, inr } from "../../lib/api";

export default function SuperDashboard() {
    const [s, setS] = useState(null);
    useEffect(() => { api.get("/super/dashboard").then(({ data }) => setS(data)).catch(() => {}); }, []);
    const cards = [
        { label: "Tenants", v: s ? s.total_tenants : "\u2026", Icon: Building2, accent: "bg-primary/10 text-primary" },
        { label: "Active Tenants", v: s?.active_tenants ?? "\u2026", Icon: Building2, accent: "bg-emerald-100 text-emerald-700" },
        { label: "Total Orders", v: s?.total_orders ?? "\u2026", Icon: ShoppingBag, accent: "bg-blue-100 text-blue-700" },
        { label: "Platform Revenue", v: s ? inr(s.total_revenue) : "\u2026", Icon: TrendingUp, accent: "bg-violet-100 text-violet-700" },
        { label: "Customers", v: s?.total_customers ?? "\u2026", Icon: Users, accent: "bg-pink-100 text-pink-700" },
    ];
    return (
        <div>
            <h1 className="text-2xl font-bold tracking-tight">Platform Overview</h1>
            <p className="text-sm text-muted-foreground mt-1">All tenants combined</p>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                {cards.map((c) => (
                    <div key={c.label} data-testid={`super-metric-${c.label}`} className="bg-card border border-border rounded-2xl p-5">
                        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${c.accent}`}><c.Icon size={18} /></div>
                        <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground font-bold mt-4">{c.label}</p>
                        <p className="text-2xl font-bold mt-1">{c.v}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
